import React, {FC, useContext} from 'react';
import {TableWrapper} from '@/components/table/TableWrapper'
import {getActivity} from '../../../logs/core/_requests'
import {getColumns} from '../../../logs/activity/columns/_columns'
import {Overview} from '../../../logs/activity/components/Overview'
import {ModalWrapperProps} from '@/components/table/core/_types'
import {Modal} from '@/components/table/modal/Modal'
import {useIntl} from 'react-intl'
import {CustomerContext} from '../CustomerContext'



const Logs = () => {
  const intl = useIntl()
  const { customer } = useContext(CustomerContext)

  if (!customer) {
    return (<></>)
  }

  const ModalWrapper: FC<ModalWrapperProps> = ({itemForUpdate, action}) => {
    return (
      <>
        {itemForUpdate !== undefined && action === 'details' && (
          <Modal title={`${intl.formatMessage({id: 'CORE.USERS.ACTIVITY.MODAL_REQUEST_DETAILS.TITLE'})}`} maxWidth={800}>
            <Overview />
          </Modal>
        )}
      </>
    )
  }

  return (
    <TableWrapper
      dataProvider={(query: string) => {
        query+= `&userId=${customer._id}`
        return getActivity(query)
      }}
      cols={getColumns(intl, true).slice(1)}
      queryId={`P2C_CUSTOMER_${customer._id}_ACTIVITY_LIST`}
      lookup={{placeholder: `${intl.formatMessage({id: 'CORE.USERS.ACTIVITY.LOOKUP_PLACEHOLDER'})}`}}
      modals={ModalWrapper}
    />
  )
}

export default Logs;
